"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Builder", {
  enumerable: true,
  get: function get() {
    return _Builder["default"];
  }
});
Object.defineProperty(exports, "DefaultPlayerSettingsContext", {
  enumerable: true,
  get: function get() {
    return _context.DefaultPlayerSettingsContext;
  }
});
Object.defineProperty(exports, "ElementPreview", {
  enumerable: true,
  get: function get() {
    return _ElementPreview["default"];
  }
});
Object.defineProperty(exports, "ForcedPlayerSettingsContext", {
  enumerable: true,
  get: function get() {
    return _context.ForcedPlayerSettingsContext;
  }
});
Object.defineProperty(exports, "Player", {
  enumerable: true,
  get: function get() {
    return _Player["default"];
  }
});
Object.defineProperty(exports, "Playlist", {
  enumerable: true,
  get: function get() {
    return _Playlist["default"];
  }
});
Object.defineProperty(exports, "allElements", {
  enumerable: true,
  get: function get() {
    return _allElements["default"];
  }
});
Object.defineProperty(exports, "assistantOptions", {
  enumerable: true,
  get: function get() {
    return _assistants.assistantOptions;
  }
});
Object.defineProperty(exports, "assistants", {
  enumerable: true,
  get: function get() {
    return _assistants.assistants;
  }
});
Object.defineProperty(exports, "backgroundOptions", {
  enumerable: true,
  get: function get() {
    return _backgrounds.backgroundOptions;
  }
});
Object.defineProperty(exports, "backgrounds", {
  enumerable: true,
  get: function get() {
    return _backgrounds.backgrounds;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Root["default"];
  }
});
var _reducer = _interopRequireDefault(require("./reducer.js"));
var _Builder = _interopRequireDefault(require("./public/Builder"));
var _Player = _interopRequireDefault(require("./public/Player"));
var _Playlist = _interopRequireDefault(require("./public/Playlist"));
var _ElementPreview = _interopRequireDefault(require("./public/ElementPreview"));
var _context = require("./context.js");
var _allElements = _interopRequireDefault(require("./allElements.js"));
var _assistants = require("./components/defaultTemplate/assistants.js");
var _backgrounds = require("./components/defaultTemplate/backgrounds.js");
var _Root = _interopRequireDefault(require("./Root.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Public components

// Routes

// Inject flow reducer
var store = window.cccisd && window.cccisd.store;
if (store) {
  if (!store.getState().flow) {
    store.injectReducer('flow', _reducer["default"]);
  }
} else if (process.env.NODE_ENV !== 'test') {
  console.error('There is no redux store at window.cccisd');
}